class XTools {
  constructor() {
    this.__toast = null;
    this.__toastContent = null;
    this.__toastTimer = 0;

    let img = new Image();
    img.src = 'https://cdn.julanling.com/h5/saas_app/suc.png';
    let img2 = new Image();
    img2.src = 'https://cdn.julanling.com/h5/saas_app/fail.png';
  }

  showToast(msg, time) {
    if (this.__hasToast) {
      this._setToastMsg(msg);
      this.__toast.style.display = 'block';
    } else {
      this.__toast = document.createElement('div');
      this.__toast.className = 'XUtils-mask';
      this.__toastContent = document.createElement('div');
      this.__toastContent.className = 'XToast-content';
      this._setToastMsg(msg);
      this.__toast.appendChild(this.__toastContent);
      document.body.appendChild(this.__toast);
      this.__hasToast = true;
      this.__toast.addEventListener('touchmove', function (ev) {
        ev.preventDefault();
      })
    }
    if (this.__toastTimer) {
      clearTimeout(this.__toastTimer);
      this.__toastTimer = 0;
    }
    this.__toastTimer = setTimeout(function () {
      this.__toast.style.display = 'none';
    }.bind(this), time ? time : 2000);
  }

  _setToastMsg(msg) {
    let toastDetail = document.createElement('div');
    toastDetail.className = 'XToast-detail';
    toastDetail.innerHTML = msg || 'Toast';
    this.__toastContent.innerHTML = "";
    this.__toastContent.appendChild(toastDetail);
  }

  showLoading(escapeBg, style = {}) {
    const retStyle = {
      // background: style.background
      ...style
    }
    // console.log(style)
    if (this.popMask && this.popMask._targetLoading) {
      this.popMask._targetLoading.className = 'x-loading-ctr x-scaleIn' + (escapeBg === true ? ' escape-bg' : "");
      this.popMask.style.display = 'block';
    } else {
      this.popMask = document.createElement('div');
      Object.keys(retStyle).forEach(key => {
        if (retStyle[key]) {
          this.popMask.style[key] = retStyle[key]
        }
      })
      this.popMask.className = 'x-mask';
      let xLoading = this.popMask._targetLoading = document.createElement('div');
      xLoading.className = 'x-loading-ctr x-scaleIn' + (escapeBg === true ? ' escape-bg' : "");
      for (let i = 0; i < 12; ++i) {
        let loadingItem = document.createElement('div');
        loadingItem.className = 'x-loading';
        loadingItem.style.webkitTransform = 'rotate(' + (30 * i) + 'deg) translateX(14px)';
        loadingItem.style.transform = 'rotate(' + (30 * i) + 'deg) translateX(14px)';
        loadingItem.style.webkitAnimationDelay = i * 50 + 'ms';
        loadingItem.style.animationDelay = i * 50 + 'ms';
        xLoading.appendChild(loadingItem);
      }
      this.popMask.appendChild(xLoading);
      document.body.appendChild(this.popMask);
    }
  }


  /**
   *
   * @param config 1: {type: 'success' | 'fail', txt: '测试'}, 2: '测试'
   */
  showTxtLoading(config = {}) {
    let txt = typeof config === 'object' ? (config.txt || '') : config.toString();
    let type = config.type || '';

    this.popMask = document.createElement('div');
    this.popMask.className = 'x-mask';
    let xLoading = this.popMask._targetTxtLoading = document.createElement('div');
    xLoading.className = 'x-loading-ctr with-txt x-scaleIn';

    let xLoadingInner =  null;

    if (type) {
      xLoadingInner = new Image();
      xLoadingInner.src = 'https://cdn.julanling.com/h5/saas_app/' + (type === 'success' ? 'suc' : 'fail') + '.png';
      xLoadingInner.className = 'x-loading-img';
    } else {
      xLoadingInner = document.createElement('div');
      xLoadingInner.className = 'x-loading-txt-ctr';
      for (let i = 0; i < 3; ++i) {
        let loadingItem = document.createElement('div');
        loadingItem.className = 'x-loading-txt';
        loadingItem.style.webkitAnimationDelay = i * 150 + 'ms';
        loadingItem.style.animationDelay = i * 150 + 'ms';
        xLoadingInner.appendChild(loadingItem);
      }
    }

    xLoading.appendChild(xLoadingInner);
    if (txt) {
      let xTxt = document.createElement('div');
      xTxt.className = 'loading-txt';
      xTxt.innerHTML = txt;

      xLoading.appendChild(xTxt);

    }

    this.popMask.appendChild(xLoading);

    document.body.appendChild(this.popMask);
  }


  hideLoading() {
    if (this.popMask) {
      this.popMask._targetLoading && (this.popMask._targetLoading.className = 'x-loading-ctr x-scaleOut');
      this.popMask._targetTxtLoading && (this.popMask._targetTxtLoading.className = 'x-loading-ctr with-txt x-scaleOut');
      setTimeout(() => {
        this.popMask.style.display = 'none';
        this.popMask._targetTxtLoading && this.popMask.removeChild(this.popMask._targetTxtLoading);
      }, 100);
    }
  }

  addStyle(styleList) {
    if (styleList && styleList.length) {
      if (!this.additionalCss) {
        let loadingStyle = document.createElement('style');
        document.head.insertBefore(loadingStyle, document.head.querySelector('style'));
        this.additionalCss = document.styleSheets[0];
        if (this.additionalCss.href) { //存在 link Css
          let tempStyle = null;
          for (let i = 0; i < document.styleSheets.length; ++i) {
            tempStyle = document.styleSheets[i];
            if (!tempStyle.href) {
              this.additionalCss = tempStyle;
              break;
            }
          }
        }
      }
      typeof styleList === 'string' ? this.additionalCss.insertRule(styleList) : styleList.forEach(item => {
        this.additionalCss.insertRule(item);
      });
    }
  }

}

export default new XTools()
